<script setup lang="ts">
  import { computed, ref, watch, defineEmits, nextTick  } from 'vue';
  import { useI18n } from '@/hooks/web/useI18n';
  
  const { t } = useI18n()
  const props = defineProps({
    modelValue: { type:Array },
    maxLen:{ type:Number, default:100}
  })
  const _value = ref<any>([])
  const onAddColor = ()=>{
      if(!props.modelValue) return
      // props.modelValue.push('#a50026')
      _value.value.push('#fff')
      emit('update:modelValue', _value.value) 
  }
  const onDeleteColor = (item,index)=>{
      if(!props.modelValue) return
      _value.value.splice(index,1)
      emit('update:modelValue', _value.value)
  }
  const onChangeColor = ()=>{
    emit('update:modelValue', _value.value)
  }

  const emit = defineEmits(['update:modelValue']);
  watch(()=>props.modelValue, (val:any) => {
    try{
      if(val){
        _value.value = [...val]
      }
    }catch(error){}
  }, 
  {
    immediate: true,
    deep: true
  })

</script>

<template>
  <div class="colors">
      <el-tag
        v-for="(color,index1) in _value"
        :key="index1"
        closable
        size="default"
        effect="plain"
        type="info"
        :disable-transitions="false"
        @close="onDeleteColor(color,index1)"
      >
        <color-picker v-model="_value[index1]" @change="onChangeColor" />
      </el-tag>
      <el-button
        v-if="_value?.length< props.maxLen"
        @click="onAddColor" 
        size="small" 
        style="height:24px;min-width:48px;">+ </el-button>
  </div>
</template>
<style lang="less" scoped>
.colors{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap:10px;
  &-icon{
    cursor: pointer;
    color: #89898A;
  }
  &-title{
    color: var(--text-on_subtle-general-primary, #323233);
    font-size: var(--font_size-16, 16px);
    font-style: normal;
    font-weight: 700;
    line-height: var(--font_size-24, 24px);
  }
  &-lft, &-rt{
    display: flex;
    align-items: center;
    gap:8px; 
  }
}
</style>